import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Stack } from '@mui/material'
import ProgressBar from 'components/progress/ProgressBar'
import { orderBy } from 'lodash'
import { getTextColorByBackground } from 'utils/ColorUtil'
import { darkBlue } from 'utils/constants/ColorTheme'
import DtoObservatoryFollowResult from 'station/dto/DtoObservatoryFollowResult'

const ThresholdIndicators = ({
    isLoaded = false,
    progress = 0,
    indicators = [],
}) => {
    const isColored = (color) => color !== 'white' && color !== '#ffffff' && color !== 'gray'

    const orderedIndicators = orderBy(
        indicators,
        [
            ({ order }) => (order === undefined ? 1 : 0),
            ({ order }) => order,
            ({ color }) => (isColored(color) ? 0 : 1),
        ],
        ['asc', 'asc', 'asc'],
    )

    return orderedIndicators.length !== 0 && (
        <Card>
            <CardContent sx={{ padding: '5px', ':last-child': { paddingBottom: 0 } }}>
                { isLoaded ? (
                    <Stack>
                        {orderedIndicators.map(ofd => (
                            <span
                                key={ofd.value}
                                style={{
                                    backgroundColor: ofd.color,
                                    padding: '3px',
                                    marginBottom: '3px',
                                    borderRadius: '3px',
                                    textAlign: 'center',
                                    color: getTextColorByBackground(ofd.color),
                                    border: (ofd.color === 'white' || ofd.color === '#ffffff') && `solid 1px ${darkBlue}`,
                                    fontSize: 10.5,
                                    lineHeight: 1.5,
                                    height: 'fit-content',
                                }}
                            >{ofd.value}</span>
                        ))}
                    </Stack>
                ) : (
                    <ProgressBar progress={progress} withMessage />
                )}
            </CardContent>
        </Card>
    )
}

ThresholdIndicators.propTypes = {
    isLoaded: PropTypes.bool,
    progress: PropTypes.number,
    indicators: PropTypes.arrayOf(PropTypes.instanceOf(DtoObservatoryFollowResult)),
}

export default ThresholdIndicators